import {Box, Button, Typography} from "@mui/material";
import {AWSContent, IS3ReadWrite} from "../content/AWSContent";
import {useContext, useState} from "react";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {FrameIOContent, IFrameIORead} from "../content/FrameIOContent";
import {ProjectDetails} from "../../../redux/types/firebase";

interface IAssetCache {
    project: string
    projects: {[project: string]: ProjectDetails}
}
export function AssetCache({project, projects}: IAssetCache) {
    const [updateAWSEnabled, setUpdateAWSEnabled] = useState(true);
    const [updateFrameIoEnabled, setUpdateFrameIoEnabled] = useState(true);
    const {get, set} = useContext(FirebaseContext);
    const handleUpdateAWS = () => {
        setUpdateAWSEnabled(false);
        get("secrets/s3-read-write").then((result) => {
            const content = new AWSContent(result as IS3ReadWrite, projects[project].name);

            content.load().then(() => {
                set(`assets/${project}/aws`, content.write()).then(() => setUpdateAWSEnabled(true));
            });
        })
    };
    const handleUpdateFrameIo = () => {
        setUpdateFrameIoEnabled(false);
        get("secrets/frame-io-read").then((result: any) => {
            const content = new FrameIOContent(result as IFrameIORead, projects[project].name);

            content.load().then(root => {
                set(`assets/${project}/frame`, content.write()).then(() => setUpdateFrameIoEnabled(true));
            });
        });
    };

    return (
        <Box>
            <Typography>
                It takes a bit of time to load assets from Frame.io (less so from AWS) so you can update them from here.
            </Typography>
            <Button disabled={! updateAWSEnabled} onClick={handleUpdateAWS}>Update AWS</Button>
            <Button disabled={! updateFrameIoEnabled} onClick={handleUpdateFrameIo}>Update Frame.io</Button>
        </Box>
    );
}